const ContentTitle = ({children}) => {
    return (
        <h1 className="page_title">{children}</h1>
    )
}

export default ContentTitle
